'use client';

import { c as _c } from "react/compiler-runtime";
import { For } from '@legendapp/state/react';
import type { CommonCmsBlockProps } from '@/components/blocks/CmsBlock';
import { cn } from '@/lib/cn';
import { TestimonialFleetCategoryTeaser } from './TestimonialFleetCategoryTeaser';
import { TestimonialsBlockCard } from './TestimonialsBlockCard';
import { TestimonialsBlockNavigation } from './TestimonialsBlockNavigation';
import { TestimonialsBlockPagination } from './TestimonialsBlockPagination';
import { useTestimonialsBlockState } from './TestimonialsBlockProvider';
interface TestimonialsBlockContentProps extends CommonCmsBlockProps {
  cardVariants: 'image' | 'simple';
  paginationColor: 'white' | 'default';
  showCta?: boolean;
  showNavigation?: boolean;
  showPagination?: boolean;
}
export function TestimonialsBlockContent(t0) {
  const $ = _c(30);
  const {
    cardVariants,
    paginationColor,
    showCta,
    showNavigation,
    showPagination
  } = t0;
  const {
    cardState$,
    viewPortRef
  } = useTestimonialsBlockState();
  const t1 = cardVariants === "simple";
  const t2 = cardVariants === "image";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = cn("relative mb-5 md:mb-0", {
      "py-4 md:py-10": t1,
      "py-4 md:py-16": t2
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = cardVariants === "simple";
  const t5 = cardVariants === "image";
  let t6;
  if ($[3] !== t4 || $[4] !== t5) {
    t6 = cn("grid mx-auto w-70 max-w-[95vw]", {
      "md:w-200 h-66 md:h-100": t4,
      "md:w-245 h-91.5 md:h-120": t5
    });
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== cardVariants) {
    t7 = card$ => <TestimonialsBlockCard className="h-full" card$={card$} variant={cardVariants} />;
    $[6] = cardVariants;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== cardState$.cards || $[9] !== t7) {
    t8 = <For each={cardState$.cards}>{t7}</For>;
    $[8] = cardState$.cards;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t6 || $[12] !== t8 || $[13] !== viewPortRef) {
    t9 = <div ref={viewPortRef} data-testid="testimonial-block-viewport" className={t6}>{t8}</div>;
    $[11] = t6;
    $[12] = t8;
    $[13] = viewPortRef;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== showNavigation) {
    t10 = showNavigation ? <TestimonialsBlockNavigation /> : null;
    $[15] = showNavigation;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t3 || $[19] !== t9) {
    t11 = <div className={t3}>{t9}{t10}</div>;
    $[17] = t10;
    $[18] = t3;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== paginationColor || $[22] !== showPagination) {
    t12 = showPagination ? <TestimonialsBlockPagination className="mt-4" color={paginationColor} /> : null;
    $[21] = paginationColor;
    $[22] = showPagination;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== showCta) {
    t13 = showCta ? <TestimonialFleetCategoryTeaser className="mt-8" /> : null;
    $[24] = showCta;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t11 || $[27] !== t12 || $[28] !== t13) {
    t14 = <>{t11}{t12}{t13}</>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
}